module.exports = __webpack_public_path__ + "img/cafe_international.ef994e9b.webp";